import React from 'react';

/**
 * Question navigation grid — numbered squares, color-coded by status.
 * Gray = unvisited, Blue = answered, Orange = flagged, Red = skipped (visited but unanswered).
 */
export default function QuestionNav({
  totalQuestions,
  currentIndex,
  answers,
  flags,
  visitedSet,
  questionIds,
  onNavigate,
  collapsed = false,
}) {
  if (collapsed) return null;

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-3">
      <div className="text-xs text-gray-500 mb-2 font-medium">Question Navigator</div>
      <div className="grid grid-cols-10 gap-1">
        {Array.from({ length: totalQuestions }, (_, i) => {
          const qId = questionIds[i];
          const isAnswered = answers[qId] !== undefined;
          const isFlagged = flags.has(qId);
          const isVisited = visitedSet.has(i);
          const isCurrent = i === currentIndex;

          let bgColor = 'bg-gray-200 text-gray-500'; // unvisited
          if (isAnswered) bgColor = 'bg-blue-500 text-white'; // answered
          if (isFlagged) bgColor = 'bg-orange-400 text-white'; // flagged
          if (isVisited && !isAnswered && !isFlagged) bgColor = 'bg-red-400 text-white'; // skipped

          return (
            <button
              key={i}
              onClick={() => onNavigate(i)}
              className={`w-7 h-7 rounded text-xs font-medium ${bgColor} ${
                isCurrent ? 'ring-2 ring-blue-600 ring-offset-1' : ''
              } hover:opacity-80 transition-all`}
            >
              {i + 1}
            </button>
          );
        })}
      </div>

      {/* Legend */}
      <div className="flex gap-4 mt-3 text-xs text-gray-400">
        <span className="flex items-center gap-1"><span className="w-2 h-2 rounded bg-gray-200" /> Not visited</span>
        <span className="flex items-center gap-1"><span className="w-2 h-2 rounded bg-blue-500" /> Answered</span>
        <span className="flex items-center gap-1"><span className="w-2 h-2 rounded bg-orange-400" /> Flagged</span>
        <span className="flex items-center gap-1"><span className="w-2 h-2 rounded bg-red-400" /> Skipped</span>
      </div>
    </div>
  );
}
